import React, { useState, useEffect } from "react";
import axios from "axios"; //library
import Header from "../layouts/Header";
import SideNav from "../layouts/Navbar";
import { useNavigate } from "react-router-dom";

function Home() {
    const navigate = useNavigate();
    const [totalUser, setTotalUser] = useState(0);
    const [totalFaq, setTotalFaq] = useState(0);
    const [totalBlog, setTotalBlog] = useState(0);
    const [totalStructure, setTotalStructure] = useState(0);
    const [totalGalery, setTotalGalery] = useState(0);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate("/");
            return;
        }
        axios.interceptors.request.use(
            (config) => {
                config.headers.authorization = token;
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        axios
            .get(`${process.env.REACT_APP_API_URL}/users/readUser`)
            .then((response) => {
                const user = response.data;
                const totalCount = user.length;
                setTotalUser(totalCount);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });

        axios
            .get(`${process.env.REACT_APP_API_URL}/faqs/readFaq`)
            .then((response) => {
                const faq = response.data;
                const totalCount = faq.length;
                setTotalFaq(totalCount);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });

        axios
            .get(`${process.env.REACT_APP_API_URL}/blog/readBlog`)
            .then((response) => {
                const blog = response.data;
                const blogCount = blog.length;
                setTotalBlog(blogCount);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });

        axios
            .get(`${process.env.REACT_APP_API_URL}/structure/readStruktur`)
            .then((response) => {
                const structure = response.data;
                const structureCount = structure.length;
                setTotalStructure(structureCount);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });

        axios
            .get(`${process.env.REACT_APP_API_URL}/galery/readGaleri`)
            .then((response) => {
                const galery = response.data;
                const galeryCount = galery.length;
                setTotalGalery(galeryCount);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    return (
        <div className="wrapper">
            <Header />
            <SideNav />
            <div className="content-wrapper">
                {/* Content Header (Page header) */}
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col">
                                <h1 className="m-0 text-center text-uppercase bold">Admin</h1>
                            </div>
                        </div>
                        {/* /.row */}
                    </div>
                    {/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        {/* Small boxes (Stat box) */}
                        <div className="row">
                            <div className="col-lg-4 col-6">
                                {/* small box */}
                                <div className="small-box bg-info">
                                    <div className="inner">
                                        <h3>{totalUser}</h3>
                                        <p>User</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-user" />
                                    </div>
                                </div>
                            </div>
                            {/* ./col */}
                            <div className="col-lg-4 col-6">
                                {/* small box */}
                                <div className="small-box bg-gray">
                                    <div className="inner">
                                        <h3>{totalFaq}</h3>
                                        <p>Faq</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-comments" />
                                    </div>
                                </div>
                            </div>
                            {/* ./col */}
                            <div className="col-lg-4 col-6">
                                {/* small box */}
                                <div className="small-box bg-warning">
                                    <div className="inner">
                                        <h3>{totalBlog}</h3>
                                        <p>Blog</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-newspaper" />
                                    </div>
                                </div>
                            </div>
                            {/* ./col */}
                            <div className="col-lg-4 col-6">
                                {/* small box */}
                                <div className="small-box bg-pink">
                                    <div className="inner">
                                        <h3>{totalFaq}</h3>
                                        <p>Program</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-tasks" />
                                    </div>
                                </div>
                            </div>
                            {/* ./col */}
                            <div className="col-lg-4 col-6">
                                {/* small box */}
                                <div className="small-box bg-teal">
                                    <div className="inner">
                                        <h3>{totalStructure}</h3>
                                        <p>Struktur</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-users-cog" />
                                    </div>
                                </div>
                            </div>
                            {/* ./col */}
                            <div className="col-lg-4 col-6">
                                {/* small box */}
                                <div className="small-box bg-indigo">
                                    <div className="inner">
                                        <h3>{totalGalery}</h3>
                                        <p>Galeri</p>
                                    </div>
                                    <div className="icon">
                                        <i className="fas fa-images" />
                                    </div>
                                </div>
                            </div>
                            {/* ./col */}
                        </div>
                    </div>
                    {/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>
        </div>
    );
}

export default Home;
